import script from "./PreferenceView.vue?vue&type=script&setup=true&lang=js"
export * from "./PreferenceView.vue?vue&type=script&setup=true&lang=js"

import "./PreferenceView.vue?vue&type=style&index=0&id=0a6dc85b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6dc85b"]])

export default __exports__